export default __webpack_public_path__ + "static/media/FSElliotPro-Regular.65112caf.otf";